import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { DimensionalUserSelectionProvider } from '@/components/datamodel/Dimensional/DimensionalUserSelectionContext';
import { FormResetProvider } from '@/dialogs/item-editor/Context/FormResetContext';

const MassUpdateForm = ({ children }: PropsWithChildren) => {

    const formMethods = useForm();

    return (
        <FormResetProvider>
            <DimensionalUserSelectionProvider>
                <FormProvider {...formMethods}>
                    <form className="tw-overflow-x-hidden">
                        {children}
                    </form>
                </FormProvider>
            </DimensionalUserSelectionProvider>
        </FormResetProvider>
    );
};

MassUpdateForm.displayName = 'MassUpdateForm';

export { MassUpdateForm };
